module.exports = __webpack_public_path__ + "img/umap.png";